var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_c('h3',[_vm._v("Publisher Profiles")])]),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.publisher_profiles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }